export default __webpack_public_path__ + "static/media/home-shop-modern-02.0411d695.jpg";